<template>
  <div class="vd-gl-content">
    <a-icon type="info-circle" style="color: #40a9ff" />
    专属关键词会触发优先级高于全局关键词
    <!-- 检索条件 -->
    <a-row class="vd-toolbar">
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item label="公众号名称">
            <a-select
              show-search
              v-model="searchForm.blog_id"
              :allowClear="true"
              placeholder="选择公众号"
              style="width: 216px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearch"
            >
              <a-select-option v-for="item in searchList" :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="所属地区">
            <a-input placeholder="请选择公众号所属地区" />
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="primary" icon="search" @click="searchInfo" />
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="danger" icon="redo" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addGlobal" icon="plus">
              全局关键词
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOnly" icon="plus">
              专属关键词
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <!-- 内容主体 -->
    <a-table
      :data-source="list"
      :pagination="pagination"
      :loading="loading"
      row-key="id"
      size="small"
    >
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="公众号" data-index="blog_name">
        <template slot-scope="item">
          {{ item ? item : '-' }}
        </template>
      </a-table-column>
      <a-table-column title="触发关键词" data-index="key_word" />
      <a-table-column title="返回内容" data-index="content" />
      <a-table-column title="全局关键词" align="center">
        <template slot-scope="item">
          <a-tag :color="item.global ? 'blue' : ''">
            {{ item.global ? '是' : '否' }}
          </a-tag>
        </template>
      </a-table-column>
      <a-table-column title="权重" data-index="weigh" />
    </a-table>
    <a-modal
      :visible="visible"
      :title="form.global ? '全局关键词' : '专属关键词'"
      okText="提交"
      @ok="ok"
      cancelText="取消"
      @cancel="cancel"
    >
      <a-form-model
        :model="form"
        layout="horizontal"
        :rules="rules"
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <template v-if="!form.global">
          <a-form-model-item label="公众号" prop="blog_id">
            <a-select
              show-search
              v-model="form.blog_id"
              :allowClear="true"
              placeholder="选择公众号"
              style="width: 216px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearch"
            >
              <a-select-option v-for="item in searchList" :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>

        <a-form-model-item label="触发关键词" prop="key_word">
          <a-input
            class="vd-input-xs"
            v-model="form.key_word"
            placeholder="触发关键词"
          />
        </a-form-model-item>

        <a-form-model-item label="返回内容" prop="content">
          <a-textarea
            class="vd-input-s"
            v-model="form.content"
            :rows="6"
            placeholder="返回内容"
          ></a-textarea>
        </a-form-model-item>

        <a-form-model-item label="绑定功能">
          <a-select
            style="width: 108px"
            v-model="form.func_id"
            :rows="6"
            placeholder="返回内容"
          >
            <a-select-option v-for="item in wordFuncList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="权重">
          <a-input-number v-model="form.weigh" placeholder="权重" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { get_blog_word_list, modify_blog_word, search_blog } from '@/api/blog'
import store from '@/store'

export default {
  name: 'Setting',
  data() {
    let validateKeyWord = (rule, value, callback) => {
      if (this.$HelperUtil.isEmpty(value)) {
        callback('请输入关键词')
      } else if (!this.$HelperUtil.strCheck(value)) {
        // 请勿输入特殊字符
        callback('请勿输入特殊字符')
      } else {
        // 数据正常
        callback()
      }
    }

    return {
      searchForm: { blog_id: undefined },
      // ------------
      visible: false,
      searchList: [],
      // ------------
      labelCol: { span: 6 },
      loading: false,
      wrapperCol: { span: 14 },
      wordFuncList: [],
      list: [],
      form: {
        id: undefined,
        blog_id: undefined,
        func_id: undefined,
        key_word: '',
        content: '',
        global: true,
        weigh: 0,
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 15,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      rules: {
        blog_id: [
          { required: true, message: '请选择绑定公众号', trigger: 'change' },
        ],
        key_word: [
          { required: true, validator: validateKeyWord, trigger: 'change' },
        ],
        content: [{ validator: validateKeyWord, trigger: 'change' }],
      },
    }
  },
  created() {
    this.getData()
    this.wordFuncList = store.getters.wordFunc
  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true
      get_blog_word_list({
        pageSize: this.pagination.pageSize,
        current: this.pagination.current,
        blog_id: this.searchForm.blog_id,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    detail(key, id) {
      this.$router.push({ path: key, query: { id: id } })
    },
    // 搜索按钮
    searchInfo() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    addGlobal() {
      this.visible = true
      this.form.global = true
    },
    addOnly() {
      this.visible = true
      this.form.global = false
    },
    cancel() {
      this.visible = false
    },
    ok() {
      // 提交数据
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify_blog_word({
            id: this.form.id,
            blog_id: this.form.blog_id,
            func_id: this.form.func_id,
            key_word: this.form.key_word,
            content: this.form.content,
            global: this.form.global,
            weigh: this.form.weigh,
          }).then((res) => {
            if (res.code === 1) {
              this.visible = false
              this.$message.success(res.msg)
              this.getData()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    // handleSearch
    handleSearch(value) {
      search_blog({ key_word: value }).then((res) => {
        if (res.code === 1) {
          this.searchList = res.list
        }
      })
    },
  },
}
</script>

<style scoped></style>
